import { useEffect, useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import './ReadingSheet.css';

/**
 * A modal sheet for the reader's pickers: slides up from the bottom on a
 * phone, sits centered on a wider screen. Built on <dialog> so focus, Esc
 * and the top layer (above the fixed header) come from the browser.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onClose
 * @param {string} props.title
 * @param {React.ReactNode} [props.leading] shown before the title, e.g. a back button
 */
const ReadingSheet = ({ open, onClose, title, leading, children }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  // A click that lands on the <dialog> itself, not its contents, is a click
  // on the backdrop.
  const handleClick = (e) => {
    if (e.target === dialogRef.current) onClose();
  };

  return (
    <dialog
      ref={dialogRef}
      className="reading-sheet"
      aria-label={title}
      onClose={onClose}
      onClick={handleClick}
    >
      <div className="reading-sheet-inner">
        <header className="reading-sheet-header">
          {leading}
          <h2>{title}</h2>
          <button type="button" className="reading-sheet-close" onClick={onClose} aria-label="Close">
            <IoClose size={22} aria-hidden="true" />
          </button>
        </header>
        <div className="reading-sheet-body">{open && children}</div>
      </div>
    </dialog>
  );
};

export default ReadingSheet;
